<template>
    <div class="industryPavilionCase">
        <swiper>
            <swiper-slide class="industryPavilionCase-tiny" v-for="(item, index) in industryPavilionCase" :key="index">
                <img :src="item" alt="" srcset="">
            </swiper-slide>
        </swiper>
        <div class="global-margin  global-inner">
            <div :class="[swidth > 768 ? 'flex' : '', 'type-list items-center']">
                <div class="all active flex justify-center items-center" v-if="swidth > 768"
                    @click="getCaseData(1, '', -1)">
                    <div v-if="lang == 'zh_cn'">
                        <p>{{ $t('case.p1').substring(0, 2) }}</p>
                        <p>{{ $t('case.p1').substring(2, 4) }}</p>
                    </div>
                    <div v-else>
                        <p>{{ $t('case.p1').split(' ')[0] }}</p>
                        <p>{{ $t('case.p1').split(' ')[1] }}</p>
                    </div>
                </div>
                <div class="all-m active flex justify-center items-center" v-else @click="getCaseData(1, '', -1)">
                    <div>
                        <p>{{ $t('case.p1') }}</p>
                    </div>
                </div>
                <div class="items w-100">
                    <ul class="flex flex-wrap" v-if="typeList.length">
                        <li v-for="(item, index) in typeList" :key="index" @click="getCaseData(1, item.id, index)"
                            :class="[swidth > 768 ? 'w-14' : 'w-25', active === index ? 'active' : '',
                            lang == 'zh_cn' ? 'white-space-nowrap' : '', swidth < 1025 ? 'en-li-height' : '']">
                            {{ item.category_name }}
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div v-else>234</div> -->
        </div>
        <div :class="[swidth > 768 ? 'flex' : '', 'flex-wrap mb-40 ']" v-loading="loading">
            <NormalWithWords v-for="(item, index) in wordsList" :key="index" :photo="item.cover_img"
                :shade="swidth > 768 ? 'hover' : 'always'" :alt="item.title"
                :class="[swidth > 768 ? 'industry-pc-words' : 'industry-m-words']"
                :showDefaultWords="swidth > 768 ? true : false" :showWords="true" @click="jumpTo(item.id)">
                <template #words>
                    <div class="industry-inner">
                        <div class="words">
                            <div class="title home-case-title">{{ item.title }}</div>
                            <!-- <div class="time" v-for="(it, idx) in item.words" :key="idx"> -->
                            <p class="time">{{ $t('case.p2') }}：{{ item.year }}</p>
                            <p class="time" v-if="item.area > 0">{{ $t('case.p3') }}：{{ item.area }} ㎡</p>
                            <p class="time">{{ $t('case.p4') }}：{{ item.service_content }}</p>
                            <p class="time" v-if="item.tag && item.tag.length > 0">
                                {{ $t('case.p5') }}：<i v-for="(it, idx) in item.tag" :key="idx"
                                    style="font-style: normal;">{{ idx !== 0 ? ', ' + it
                                        : it
                                    }}</i>
                            </p>
                            <!-- </div> -->
                        </div>
                    </div>
                </template>
            </NormalWithWords>
            <el-empty class="m-auto" description="暂无数据" :image-size="swidth > 768 ? 200 : 100"
                v-show="!wordsList.length"></el-empty>
        </div>
        <el-pagination style="text-align: center; margin: 40px auto; margin-bottom: 50px" background
            layout="prev, pager, next" :page-size="page_size" :total="total" :current-page.sync="page"
            @current-change="handleCurrentChange" v-if="wordsList.length && total_page > 1"></el-pagination>
    </div>
</template>
<script>
import NormalWithWords from "../components/NormalWithWords";


import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    components: {
        NormalWithWords,
        swiper, swiperSlide
    },
    props: {
        swidth: {
            type: Number
        }
    },
    data() {
        return {
            swiperOptionThumbs: {
                loop: true,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
            },
            industryPavilionCase: [],
            lang: localStorage.getItem("333f-locale-lang") || "zh_cn",
            wordsList: [
                {
                    pic: require("@/assets/images/solution1.png"),
                    title: this.$t("solution.i1"),
                    words: [
                        this.$t("solution.i2"),
                        this.$t("solution.i3"),
                        this.$t("solution.i4"),
                    ],
                },
                {
                    pic: require("@/assets/images/solution2.png"),
                    title: this.$t("solution.i5"),
                    words: [
                        this.$t("solution.i6"),
                        this.$t("solution.i7"),
                        this.$t("solution.i8"),
                    ],
                },
            ],
            typeList: [],
            page: 1,
            page_size: 12,
            total: 0,
            total_page: 0,
            active: -1,
            category_id: '',
            loading: true,
        };
    },
    mounted() {
        this.getTypeList('getbanner')
        this.getTypeList()
    },
    methods: {
        jumpTo(id) {
            this.$router.push(`/industryPavilionCaseDetail?id=${id}`)
        },
        getTypeList(type) {
            this.$http.get('/common/category/getList', {
                pid: type ? 0 : sessionStorage.getItem('333f-now-tab') || 0,
                lang_code: this.lang,
                'to-tree': 0
            }).then((res) => {
                if (res.code == 200) {

                    if (type) {
                        let nowtab = Number(sessionStorage.getItem('333f-now-tab'))
                        res.data.map(item => {
                            if (nowtab == item.id) this.industryPavilionCase = [item.banner_url]
                        })
                    } else {

                        this.typeList = res.data;
                        this.getCaseData(1, '', -1)
                    }
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        getCaseData(page = 1, category_id, index) {
            this.active = index
            this.page = page
            this.category_id = category_id
            this.loading = true
            this.$http.get("/api/cases/pageList", {
                page: this.page,
                per_page: this.page_size,
                category_id: category_id
            }).then((res) => {
                if (res.code == 200) {
                    this.wordsList = res.data.data;
                    this.loading = false
                    this.total = res.data.total
                    this.total_page = res.data.last_page
                } else {
                    this.loading = false
                    // this.$message.error(res.msg);
                }
            });
        },
        handleCurrentChange(page) {
            this.getCaseData(page, this.category_id, this.active)
        }
    },
};
</script>
<style scoped lang="less">
.industryPavilionCase {
    .industryPavilionCase-tiny {
        img {
            width: 100%;
            height: fit-content;
            min-height: 380px;
        }
    }

    .type-list {
        color: @text-defauft-color;
        font-size: 26px;
        margin: 20px 0;

        .all {
            line-height: 1;
            text-align: center;
            min-width: 120px;
            min-height: 120px;
            border-radius: 5px;
            margin-right: 10px;

            p {
                text-align: center;
                line-height: 36px;
                letter-spacing: 2px;
            }
        }

        .all-m {
            line-height: 1;
            text-align: center;
            width: 100%;
            height: 56px;
            border-radius: 5px;
            margin-right: 10px;
            margin-bottom: 20px;

            p {
                text-align: center;
                line-height: 36px;
                letter-spacing: 2px;
            }
        }

        .items {
            font-size: 20px;

            ul {
                li {
                    text-align: center;
                    background-color: #fff;
                    line-height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 6px 0;
                    // white-space: nowrap;
                }

                .en-li-height {
                    line-height: 30px;
                    padding: 8px 0;
                }

            }
        }

        // .active {
        //     background: @primaryColor;
        //     color: #fff;
        // }
    }

    .active {
        background-color: @primaryColor !important;
        color: #fff;
        border-radius: 3px;
    }


    // .solution-industry {
    //     display: flex;
    //     flex-wrap: wrap;
    //     margin-top: 20px;
    .industry-pc-words {
        width: 33%;
        margin: 0 0.3% 6px 0;

        &:nth-child(3n) {
            margin-right: 0;
        }
    }

    .industry-m-words {
        margin: 0 auto 20px;
        width: 96%;
    }

    .industry-inner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .words {
            padding: 0 62px;
            font-size: 16px;
            font-weight: normal;
            color: #fff;

            .title {
                // text-align: center;
                font-weight: 500;
                font-size: 28px;
                color: @primaryColor;
                font-family: Arial-BoldMT;
                white-space: break-spaces;
                margin-bottom: 10px;
            }

            .time {
                // text-align: center;
                font-size: 16px;
                margin-bottom: 5px;
                line-height: 19px;
            }
        }
    }

    .w-14 {
        width: 14%;
    }

    .w-130 {
        width: 130px;
    }

    @media (max-width: 900px) {
        .industryPavilionCase-tiny {
            img {
                height: 400px !important;
                object-fit: cover;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/industryPavilionCase.vue